import { render, staticRenderFns } from "./NumberItem.vue?vue&type=template&id=44aff500&scoped=true&"
import script from "./NumberItem.vue?vue&type=script&lang=js&"
export * from "./NumberItem.vue?vue&type=script&lang=js&"
import style0 from "./NumberItem.vue?vue&type=style&index=0&id=44aff500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aff500",
  null
  
)

export default component.exports